module.exports = __webpack_public_path__ + "static/media/logo.dcb489ea.png";